import { render, staticRenderFns } from "./verify-file-upload.vue?vue&type=template&id=797805a1&scoped=true"
import script from "./verify-file-upload.vue?vue&type=script&lang=ts"
export * from "./verify-file-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797805a1",
  null
  
)

export default component.exports